import React from 'react';
import { ButtonProps } from 'antd/lib/button';

import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import CcNode from '../../../services/models/CcNode';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import JobActionButton from '../../Jobs/JobActionButton';
import NodeResyncForm from './NodeResyncForm';

export default NodeResyncButton;

export type NodeResyncButtonProps = ButtonProps & {
    node: CcNode;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function NodeResyncButton({
    node,
    children,
    onSuccess,
    ...rest
}: NodeResyncButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.RESTART}
                    clusterId={node.clusterid}
                    extraKey={[node.hostname, node.port]}
                    {...rest}
                >
                    {children || 'Resync node'}
                </JobActionButton>
            }
            form={<NodeResyncForm node={node} onSuccess={onSuccess} />}
        />
    );
}
